import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { CurrencyResponseSchema } from "../response/PreferedCurrencyResponse";

const API_VERSION = "v3";

export const usePreferedCurrency = () => {
    return useQuery({
        queryKey: ['currency', 'list'],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/${API_VERSION}/currency-list`);

                const validationResult = CurrencyResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Failed to fetch currencies");
                }
                return validationResult.data;

            } catch (error) {
                console.error("Failed to fetch currencies", error);
                throw error;
            }
        },
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};